import { Slider, Slide } from 'components/Slider/Slider';
import { Button } from 'components/buttons/Button/Button';
import HeroNewsCard from 'pages/Homepage/Hero/HeroNewsCard';
import hero from 'videos/hero.mp4';
import 'swiper/css';
import './styles.scss';
import GradientText from 'components/GradientText';
import { useSelector } from 'react-redux';

const Hero = () => {
    // @ts-ignore
    const { first_screen_title, news_posts, banner_title } = useSelector(state => state?.homepage?.data?.data) || {};

    const onFullPageSolutions = () => {
        window.location.href = '#information-wrapper';
    };

    return (
        <section className="container">
            <div className="hero">
                <video autoPlay loop muted>
                    <source src={hero} type="video/mp4" />
                </video>
                <GradientText textColor="white">
                    <h1 dangerouslySetInnerHTML={{ __html: first_screen_title }} />
                </GradientText>
            </div>
            <div className="information-wrapper">
                <div className="information-wrapper__offer-section">
                    <GradientText size="super-small" textColor="white">
                        <span dangerouslySetInnerHTML={{ __html: banner_title }} />
                    </GradientText>
                    <Button type="white-arrow" onClick={onFullPageSolutions} />
                </div>
                <div className="information-wrapper__box-for-border"></div>
                <div className="information-wrapper__box-for-border radius16"></div>
                <div className="information-wrapper__box-for-border location-left"></div>
                <div className="information-wrapper__box-for-border location-left radius16"></div>
                <div className="information-wrapper__news-wrapper">
                    <Slider className="slider-head">
                        {news_posts?.map(post => (
                            <Slide key={post.slug}>
                                <HeroNewsCard card={post} array={news_posts} />
                            </Slide>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default Hero;
